import React, { useState } from 'react';
import { OwcTypography } from '@one/react';
import moment from 'moment';
import './ConflictPanel.scss';

const DATE_FORMAT = 'D-MMM-YYYY, h:mm a';

const ConflictPanel = ({ conflicts = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!conflicts || conflicts.length === 0) {
    return null;
  }

  const conflictCount = conflicts?.reduce((total, conflict) => {
    return total + (conflict?.conflicts?.length || 0);
  }, 0);

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={`conflict-panel-button ${isOpen ? 'conflict-panel-button--open' : ''}`}>
        <button
          className="conflict-panel-trigger"
          onClick={togglePanel}
          aria-label={`${conflictCount} conflicts detected`}
        >
          <div className="conflict-panel-trigger-content">
            <div className="conflict-panel-trigger-text">
              <span className="conflict-panel-trigger-title">{conflictCount} conflicts</span>
            </div>
          </div>
        </button>
      </div>

      <div className={`conflict-panel ${isOpen ? 'conflict-panel--open' : ''}`}>
        <div className="conflict-panel-content">
          {(
            <div className="conflict-panel-placeholder">
              {conflicts.length === 0 ? (
                <OwcTypography variant="title3"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}>
                  No conflicts found
                </OwcTypography>
              ) : (
                <>
                  <OwcTypography
                    variant="subtitle2"
                    className="conflict-panel--header"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  >
                    {conflictCount} conflicts in {conflicts?.length} occurance(s)
                  </OwcTypography>
                  {conflicts.map((conflict, conflictIndex) => (
                    <div key={`conflict-${conflictIndex}`} style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                      <OwcTypography
                        variant="body1"
                        className="conflict-panel--occurance"
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}>
                        <strong>Occurance #{conflict.occurrenceIndex}</strong> ({moment(conflict.startDate).format(DATE_FORMAT)} - {moment(conflict.endDate).format(DATE_FORMAT)})
                      </OwcTypography>
                      {conflict.conflicts?.map((conflictDetail, detailIndex) => (
                        <React.Fragment key={`conflict-detail-${conflictIndex}-${detailIndex}`}>
                          <OwcTypography
                            variant="body1"
                            className="conflict-detail"
                            placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                          >
                            {conflictDetail.resourceName}:
                          </OwcTypography>
                          <OwcTypography
                            variant="body1"
                            className="conflict-detail"
                            style={{ color: '#DB4D71' }}
                            placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                          >
                            {moment(conflictDetail.activeEventDates?.[0]).format(DATE_FORMAT)} - {moment(conflictDetail.activeEventDates?.[1]).format(DATE_FORMAT)}
                          </OwcTypography>
                        </React.Fragment>
                      )) || (
                          <OwcTypography variant="body2" className="no-details" placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}>
                            No conflict details available
                          </OwcTypography>
                        )}
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ConflictPanel;
